<div class="alert-popup" (click)="onCloseClick()">
  <div class="alert-popup__content">
    <h3 *ngIf="title">
      {{ title }}
    </h3>
    <p *ngIf="message">
      {{ message }}
    </p>
    <div class="alert-popup__actions">
      <button  [ngStyle]="{
        'background': configs?.colors?.bot_message_button_background,
        color: configs?.colors?.bot_message_text,
        border: '1px solid ' + configs?.colors?.bot_message_border,
        'font-family': configs?.fonts?.chat_menu_font,
         '--hover-color': configs?.colors?.send_button_background || '#256EFF'
      }" (click)="onCloseClick()"
      class="hover-button">Ok</button>
    </div>
  </div>
</div>
